/**
 * @classdesc A great library for building reports.
 * @copyright All rights reserved
 */
import Utilities from './utilities';
import DataAccessLibrary from './dataAccessLibrary';

const MyInsights = DataAccessLibrary;
export { MyInsights, Utilities };
